/* Natural Joint homepage helpers: click-to-play video thumbnails (nj-home-* sections) */
(function () {
  if (window.__nhVideoBound) return;
  window.__nhVideoBound = true;

  function play(box) {
    if (!box || box.getAttribute('data-playing') === 'true') return false;
    var tpl = box.querySelector('template.nh-vt');
    if (!tpl) return false;
    box.setAttribute('data-playing', 'true');
    box.removeAttribute('role');
    box.removeAttribute('tabindex');
    var node = tpl.content.firstElementChild.cloneNode(true);
    box.querySelectorAll('.nh-play,.nh-name,img').forEach(function (el) { el.style.display = 'none'; });
    box.appendChild(node);
    try { var p = node.play(); if (p && p.catch) p.catch(function () {}); } catch (err) {}
    return true;
  }

  document.addEventListener('click', function (e) {
    var box = e.target.closest && e.target.closest('.nh [data-nh-video]');
    if (box && box.getAttribute('data-playing') !== 'true' && play(box)) e.preventDefault();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var box = e.target.closest && e.target.closest('.nh [data-nh-video][role="button"]');
    if (box && play(box)) e.preventDefault();
  });
})();
